import { Card, CardActionArea, CardMedia, CardContent, Typography, Grid } from '@mui/material';
import machineDefaultImage from '../../images/machineImageEmpty.svg';
import { entityGridPhotoUrl } from '../entityImage/entityImageConfig';
import { useNavigate } from 'react-router-dom';
import Skeleton from '@mui/material/Skeleton';
import React, { useCallback } from 'react';
import '../../css/companies/companyCardView.css';

const CompanyGridViewData = React.memo(({ index, style, data }) => {

    const { companies, columns, filteredCompaniesCount } = data;
    const navigate = useNavigate();
    const startIndex = index * columns;
    const endIndex = Math.min(startIndex + columns, filteredCompaniesCount);

    const handleCompanyClick = useCallback((companyId) => navigate(`entreprise_details/${companyId}`), [navigate]);

    return (
        <Grid style={style} key={index} container spacing={2}>
            {Array.from({ length: endIndex - startIndex })?.map((_, idx) => {
                const companyIndex = startIndex + idx;
                const company = companies[companyIndex];

                return (
                    <Grid item xs={12} sm={6} md={4} lg={3} key={company ? company.id : `skeleton-${companyIndex}`}>
                        <Card className='companies_gridview_card'>
                            <CardActionArea onClick={company ? () => handleCompanyClick(company.id) : undefined}>
                                {company ? (
                                    <>
                                        <CardMedia
                                            component="img"
                                            height="192"
                                            loading='lazy'
                                            decoding='async'
                                            image={entityGridPhotoUrl(company, 'company', { size: 'small', fallback: machineDefaultImage })}
                                            alt={company?.name}
                                        />
                                        <CardContent className='companies_gridview_card_CardContent'>
                                            <Typography className='companies_gridview_company_name' component="div">{company?.name}</Typography>
                                            <Typography className='companies_gridview_company_adress' component="div">{company?.street_address || '--'}</Typography>
                                        </CardContent>
                                    </>
                                ) : (
                                    <>
                                        <Skeleton variant="rectangular" height={192} />
                                        <CardContent className='machines_gridview_card_CardContent'>
                                            <Skeleton variant="text" />
                                            <Skeleton variant="text" />
                                        </CardContent>
                                    </>
                                )}
                            </CardActionArea>
                        </Card>
                    </Grid>
                );
            })}
        </Grid>
    );
});

export default CompanyGridViewData;